var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"decorative-divider",attrs:{"preserveAspectRatio":"none","viewBox":" 0 0 100 100"}},[_c('polygon',{attrs:{"fill":_vm.fill,"points":_vm.points}})])
}
var staticRenderFns = []

export { render, staticRenderFns }